import { FormControl, InputLabel, Select } from "@mui/material";
import cssVars from '../../styles/vars.module.scss'

const FormControlSelect = ({ children, label, value = "", onChange = () => { }, ...props }) => {

    return (
        <FormControl fullWidth {...props} >
            <InputLabel style={{ color: `${cssVars.extraDarkGray} ! important` }} >{label}</InputLabel>
            <Select
                label={label}
                value={value}
                fullWidth
                onChange={(e) => { onChange(e) }}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 240,
                        },
                    },
                }}
            >
                {children}
            </Select>
        </FormControl>
    );
}

export default FormControlSelect;